import {createSlice} from '@reduxjs/toolkit'

export const salesTargetInitialState = {
  initialTargetName: '',
  uuid: null,
  formData: {
    activeDisplay: true,
    displayStartDate: '',
    displayEndDate: '',
  },
  displayContent: {
    en: {
      title: null,
      Category: null,
      parentCategory: '',
      childCategory: '',
      excerpt: null,
      terms: '',
    },
  },
  targetName: null,
  ignoreSkuList: true,
  targetType: '',
  joinCampaignFlag: false,
  VATIncluded: false, //Exclude tax from goa is true then false
  roundPointsValue: 0,
  roundUpPointsFlag: true,
  offlineOrdersIncluded: false, // Include Offline Orders
  cepRefId: null,
  displayStartDate: '',
  displayEndDate: '',
  activeStartDate: '',
  activeEndDate: '',
  targetDeliveryDate: '',
  pointsDeliveryDate: '',
  pointsDisplay: 'Individual',
  awardPointsImmedFlag: false,

  ruleSet: {
    includeAllProductsByDefault: true,
    skipNonAssorted: false,
    rules: [
      {
        includedCategories: [],
        includedProductIds: [],
        excludedCategories: [],
        excludedProductIds: [],
      },
    ],
  },
  media: [
    {
      cepRefId: '7912062',
      id: null,
      index: '0',
      optIn: null,
      title: 'abc',
      language: 'es_MX',
      filename: 'bg2.jpg',
      imageUrl: '',
    },
  ],
  childRuleSet: null,
  status: null,
  storeList: '',
  id: 1,

  selectedCategory: [],
  excludedProducts: [],
  includedProducts: [],
  tabWiseData: {
    parent: {
      ignoreSkuList: false,
      selectedCategory: [],
      includedProducts: [],
      excludedProducts: [],
      selectedRows: [],
      mediaFile: [],
      ruleSet: {
        includeAllProductsByDefault: true,
        skipNonAssorted: false,
        rules: [
          {
            includedCategories: [],
            includedProductIds: [],
            excludedCategories: [],
            excludedProductIds: [],
          },
        ],
      },
    },
    child: {
      ignoreSkuList: false,
      selectedRows: [],
      selectedCategory: [],
      includedProducts: [],
      excludedProducts: [],
      mediaFile: [],
      ruleSet: {
        includeAllProductsByDefault: false,
        skipNonAssorted: false,
        rules: [
          {
            includedCategories: [],
            includedProductIds: [],
            excludedCategories: [],
            excludedProductIds: [],
          },
        ],
      },
    },
  },
  displayContentMedia: {
    title: null,
    imageId: '',
    imageUri: '',
    imageBase64: '',
    optIn: false,
  },
  selectedSalesTargetProduct: [],
  isAllCategories: false,
  isAllCategoriesChild: false,
  preRequisiteTarget: '',
  selectedType: '',
  mediaFile: [], // Add this new field
  child: {
    displayContent: {
      en: {
        title: null,
        Category: null,
        parentCategory: '',
        childCategory: '',
        excerpt: null,
        terms: '',
      },
    },
  },
  preRequisiteParentTab: {
    categoryTable: false,
    uploadFile: false,
  },
  preRequisiteChildTab: {
    categoryTable: false,
    uploadFile: false,
  },
}


const assignProductIdsForIncludeExclude = (state, tab) => {
  assignProductIds(state, tab, 'includedProducts', 'includedProductIds');
  assignProductIds(state, tab, 'excludedProducts', 'excludedProductIds');
  
}
const assignProductIds = (state, tab, assignFromKey, assignToKey)=>{
  const rule = state.tabWiseData[tab]?.ruleSet?.rules?.[0];
  if(rule){
    const arrExists = rule[assignToKey];
    if (arrExists) {
      rule[assignToKey]  = state.tabWiseData[tab]?.[assignFromKey] || []
    }
  }
}
const salesTargetSlice = createSlice({
  name: 'salesTarget',
  initialState: salesTargetInitialState,
  reducers: {
    setSalesTarget: (state, action) => {
      // Completely replace state with the provided dataList (action.payload)
      return {...action.payload}
    },
    setSalesTargetDisplayContent: (state, action) => {
      return {
        ...state,
        displayContent: action.payload,
      }
    },
    resetSalesTarget: () => salesTargetInitialState,
    setSalesTargetChildDisplayContent: (state, action) => {
      return {
        ...state,
        child: {
          ...state.child,
          displayContent: action.payload,
        },
      }
    },
    setSalesTargetDisplayContentMedia: (state, action) => {
      return {
        ...state,
        displayContentMedia: action.payload,
        media: [action.payload],
      }
    },
    setPrerequisiteTarget: (state, action) => {
      return {
        ...state,
        preRequisiteTarget: action.payload,
      }
    },
    resetSalesTargetDisplayContentMedia: state => {
      return {
        ...state,
        displayContentMedia: {
          title: '',
          imageId: '',
          imageUri: '',
          imageBase64: '',
        },
        media: [],
      }
    },
    setUploadOutcome: (state, action) => {
      const {activeTab, totalCount, nonExistentIds} = action.payload
      if (state.tabWiseData[activeTab]) {
        state.tabWiseData[activeTab].uploadOutcome = {totalCount, nonExistentIds}
      }
    },
    resetUploadOutcome: (state, action) => {
      const {activeTab} = action.payload
      if (state.tabWiseData[activeTab]) {
        state.tabWiseData[activeTab].uploadOutcome = {totalCount: 0, nonExistentIds: []}
      }
    },
    setSalesTargetFormData: (state, action) => {
      return {
        ...state,
        ...action.payload,
        activeStartDate: action.payload.startDate,
        activeEndDate: action.payload.endDate,
        displayStartDate: action.payload.activeDisplay ? action.payload.startDate : action.payload.displayStartDate,
        displayEndDate: action.payload.activeDisplay ? action.payload.endDate : action.payload.displayEndDate,
        formData: action.payload,
        roundPointsValue: action.payload.roundOffValue,
        roundUpPointsFlag: action.payload.roundUpPointsFlag ? true : false,
        VATIncluded: !action.payload.excludeTaxFromGoal ? true : false,
        joinCampaignFlag: action.payload.joinCampaignFlag ? true : false,
        excludeTaxFromGoal: action.payload.excludeTaxFromGoal ? true : false,
        offlineOrdersIncluded: action.payload.offlineOrdersIncluded ? true : false,
        awardPointsImmedFlag: action.payload.awardPointsImmedFlag ? true : false,
        targetDeliveryDate: action.payload.targetDeliveryDate,
        selectedSalesTargetProduct: action.payload.selectedSalesTargetProduct
          ? action.payload.selectedSalesTargetProduct
          : [],
        isAllCategories: action.payload.isAllCategories,
        selectedType: action.payload.selectedType || state.selectedType, // Preserve selectedType when not provided in payload
      }
    },
    setSalesTargetSelectedCategory: (state, action) => {
      const {activeTab, payload, excludedCategories} = action.payload
      return {
        ...state,
        tabWiseData: {
          ...state.tabWiseData,
          [activeTab]: {
            ...state.tabWiseData?.[activeTab],
            selectedCategory: payload,
            ruleSet: {
              ...state.tabWiseData?.[activeTab].ruleSet,
              //includeAllProductsByDefault: false,
              rules: [
                {
                  ...state.tabWiseData?.[activeTab].ruleSet?.rules[0],
                  includedCategories: payload?.map(cat => cat.id),
                  ...(excludedCategories && { excludedCategories: excludedCategories }),
                },
              ],
            },
          },
        },
      }
    },
    setIgnoreSkuList: (state, action) => {
      const {activeTab, ignoreSkuList} = action.payload
      return {
        ...state,
        tabWiseData: {
          ...state.tabWiseData,
          [activeTab]: {
            ...state.tabWiseData?.[activeTab],
            ignoreSkuList: ignoreSkuList,
          },
        },
      }
    },
    setSalesTargetIsAllCategories: (state, action) => {
      return {
        ...state,
        isAllCategories: action.payload,
      }
    },
    setRuleSet: (state, action) => {
      const {ruleSet} = action.payload
      if (state.tabWiseData.activeTab === 'parent' || state.tabWiseData.activeTab === 'child') {
        return {
          ...state,
          tabWiseData: {
            ...state.tabWiseData,
            [state.tabWiseData.activeTab]: {
              ...state.tabWiseData?.[state.tabWiseData.activeTab],
              ruleSet: {
                ...ruleSet,
                rules: [
                  {
                    ...ruleSet?.rules[0],
                    includedCategories: state.tabWiseData?.[state.tabWiseData.activeTab]?.selectedCategory?.map(
                      cat => cat.id
                    ),
                  },
                ],
              },
            },
          },
        }
      }
      return {...state, ruleSet: ruleSet}
    },
    resetRuleSet: (state, action) => {
      if (state.tabWiseData.activeTab === 'parent' || state.tabWiseData.activeTab === 'child') {
        const currentSelectedRows = state.tabWiseData?.[state.tabWiseData.activeTab]?.selectedRows || [];
        return {
          ...state,
          ...action.payload,
          tabWiseData: {
            ...state.tabWiseData,
            [state.tabWiseData.activeTab]: {
              ...state.tabWiseData?.[state.tabWiseData.activeTab],
              ruleSet: {...salesTargetInitialState.ruleSet,
                rules: [{
                  includedCategories:  state.tabWiseData?.[state.tabWiseData.activeTab]?.ruleSet?.rules[0]?.includedCategories || [],
                  includedProductIds: [],
                  excludedCategories:  state.tabWiseData?.[state.tabWiseData.activeTab]?.ruleSet?.rules[0]?.excludedCategories || [],
                  excludedProductIds: [],
                }]
              },
              includedProducts: [],
              excludedProducts: [],
              selectedRows: currentSelectedRows
            },
          },
        }
      }
      return {...state, ruleSet: salesTargetInitialState.ruleSet}
    },
    setStoreListUrl: (state, action) => {
      return {...state, storeList: action.payload}
    },
    // Add a product to the excluded list
    // First removes it from included list if present, then adds to excluded list if not already there
    addExcludedProduct: (state, action) => {
      const {productId, activeTab} = action.payload

      // Initialize tabWiseData[activeTab] if it doesn't exist
      if (!state.tabWiseData[activeTab]) {
        state.tabWiseData[activeTab] = {
          ignoreSkuList: false,
          selectedCategory: [],
          includedProducts: [],
          excludedProducts: [],
          selectedRows: [],
          mediaFile: [],
          ruleSet: {
            includeAllProductsByDefault: activeTab === 'parent',
            skipNonAssorted: false,
            rules: [
              {
                includedCategories: [],
                includedProductIds: [],
                excludedCategories: [],
                excludedProductIds: [],
              },
            ],
          },
        }
      }

      // Initialize arrays if they don't exist
      if (!state.tabWiseData[activeTab].includedProducts) {
        state.tabWiseData[activeTab].includedProducts = []
      }
      if (!state.tabWiseData[activeTab].excludedProducts) {
        state.tabWiseData[activeTab].excludedProducts = []
      }

      state.tabWiseData[activeTab].includedProducts = state.tabWiseData[activeTab].includedProducts.filter(
        id => id !== productId
      )
      if (!state.tabWiseData[activeTab].excludedProducts.includes(productId)) {
        state.tabWiseData[activeTab].excludedProducts.push(productId)
      }
      assignProductIdsForIncludeExclude(state, activeTab);
    },

    // Remove a product from the excluded list
    // Simply filters out the specified product ID from the excluded products array
    removeExcludedProduct: (state, action) => {
      const {productId, activeTab} = action.payload

      if (!state.tabWiseData[activeTab]?.excludedProducts) {
        return
      }

      state.tabWiseData[activeTab].excludedProducts = state.tabWiseData[activeTab].excludedProducts.filter(
        id => id !== productId
      )
    },

    setSelectedRows: (state, action) => {
      const {activeTab, selectedRows} = action.payload

      if (!state.tabWiseData[activeTab]) {
        state.tabWiseData[activeTab] = { selectedRows: [] }
      }

      state.tabWiseData[activeTab].selectedRows = selectedRows
    },

    removeSelectedRows: (state, action) => {
      const {productId, activeTab} = action.payload

      if (!state.tabWiseData[activeTab]?.selectedRows) {
        return
      }

      state.tabWiseData[activeTab].selectedRows = state.tabWiseData[activeTab].selectedRows.filter(
        id => id !== productId
      )
    },

    // Add a product to the included list
    // First removes it from excluded list if present, then adds to included list if not already there
    addIncludedProduct: (state, action) => {
      const {productId, activeTab} = action.payload

      // Initialize tabWiseData[activeTab] if it doesn't exist
      if (!state.tabWiseData[activeTab]) {
        state.tabWiseData[activeTab] = {
          ignoreSkuList: false,
          selectedCategory: [],
          includedProducts: [],
          excludedProducts: [],
          selectedRows: [],
          mediaFile: [],
          ruleSet: {
            includeAllProductsByDefault: activeTab === 'parent',
            skipNonAssorted: false,
            rules: [
              {
                includedCategories: [],
                includedProductIds: [],
                excludedCategories: [],
                excludedPropertyIds: [],
              },
            ],
          },
        }
      }

      if (!state.tabWiseData[activeTab].includedProducts) {
        state.tabWiseData[activeTab].includedProducts = []
      }
      if (!state.tabWiseData[activeTab].excludedProducts) {
        state.tabWiseData[activeTab].excludedProducts = []
      }

      state.tabWiseData[activeTab].excludedProducts = state.tabWiseData[activeTab].excludedProducts.filter(
        id => id !== productId
      )
      if (!state.tabWiseData[activeTab].includedProducts.includes(productId)) {
        state.tabWiseData[activeTab].includedProducts.push(productId)
      }
     assignProductIdsForIncludeExclude(state, activeTab);
    },

    // Remove a product from the included list
    // Simply filters out the specified product ID from the included products array
    removeIncludedProduct: (state, action) => {
      const {productId, activeTab} = action.payload

      if (!state.tabWiseData[activeTab]?.includedProducts) {
        return
      }

      state.tabWiseData[activeTab].includedProducts = state.tabWiseData[activeTab].includedProducts.filter(
        id => id !== productId
      )
    },
    setProductCsvFile: (state, action) => {
      const {activeTab, mediaFile} = action.payload
      return {
        ...state,
        tabWiseData: {
          ...state.tabWiseData,
          [activeTab]: {
            ...state.tabWiseData?.[activeTab],
            mediaFile: mediaFile,
          },
        },
        mediaFile: mediaFile,
      }
    },
    resetProductCsvFile: (state, action) => {
      const {activeTab} = action.payload
      return {
        ...state,
        tabWiseData: {
          ...state.tabWiseData,
          [activeTab]: {
            ...state.tabWiseData?.[activeTab],
            mediaFile: [],
          },
        },
        mediaFile: [],
      }
    },
    setPageActiveTab: (state, action) => {
      const {activeTab, pageTitle} = action.payload
      if (pageTitle === 'Products') {
        return {
          ...state,
          tabWiseData: {...state.tabWiseData, activeTab: activeTab},
        }
      } else return state
    },
    setSelectedType: (state, action) => {
      return {
        ...state,
        selectedType: action.payload,
      }
    },
    setInitialTargetName: (state, action) => {
      return {
        ...state,
        initialTargetName: action.payload,
      }
    },
    addPreRequisiteParentTab: (state, action) => {
      return {
        ...state,
        preRequisiteParentTab: action.payload,
      }
    },
    addPreRequisiteChildTab: (state, action) => {
      return {
        ...state,
        preRequisiteChildTab: action.payload,
      }
    },
    addMediaTitle: (state, action) => {
      return {
        ...state,
        displayContentMedia: {
          ...state.displayContentMedia,
          title: action.payload,
        },
      }
    },
    addMediaId: (state, action) => {
      return {
        ...state,
        displayContentMedia: {
          ...state.displayContentMedia,
          imageId: action.payload,
        },
      }
    },
    setMediaOptIn: (state, action) => {
      return {
        ...state,
        displayContentMedia: {
          ...state.displayContentMedia,
          optIn: action.payload,
        },
      }
    },
    setTargetType: (state, action) => {
      return {
        ...state,
        targetType: action.payload,
      }
    },
    setSalesTargetUuid: (state, action) => {
      return {
        ...state,
        uuid: action.payload,
      }
    },
  },
})

export const {
  setSalesTarget,
  setSalesTargetDisplayContent,
  setSalesTargetDisplayContentMedia,
  resetSalesTargetDisplayContentMedia,
  setSalesTargetChildDisplayContent,
  resetSalesTarget,
  setSalesTargetFormData,
  setSalesTargetSelectedCategory,
  addExcludedProduct,
  removeExcludedProduct,
  addIncludedProduct,
  removeIncludedProduct,
  setRuleSet,
  setStoreListUrl,
  resetRuleSet,
  setPrerequisiteTarget,
  setSalesTargetIsAllCategories,
  setProductCsvFile,
  resetProductCsvFile,
  setIgnoreSkuList,
  setSelectedRows,
  removeSelectedRows,
  setPageActiveTab,
  setUploadOutcome,
  resetUploadOutcome,
  setSelectedType,
  setInitialTargetName,
  addPreRequisiteParentTab,
  addPreRequisiteChildTab,
  addMediaTitle,
  setMediaOptIn,
  setTargetType,
  addMediaId,
  setSalesTargetUuid
} = salesTargetSlice.actions

export const salesTargetSliceReducer = salesTargetSlice.reducer
